import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { FirebaseError } from "firebase/app";
import { ZodError } from "zod";

import { createStripeCheckout } from "../firebase";
import { type CDRRequest, validateCDRRequest } from "../types/cdr-request.type";
import type { StripeCheckoutResponse } from "../types/response.type";

export const checkoutService = createApi({
	baseQuery: fakeBaseQuery(),
	endpoints: (build) => ({
		createCheckoutSession: build.mutation<StripeCheckoutResponse, CDRRequest>({
			queryFn: async (cdrRequest: CDRRequest) => {
				try {
					const validatedRequest = validateCDRRequest(cdrRequest);
					const response = await createStripeCheckout(validatedRequest);
					return { data: response.data };
				} catch (err: unknown) {
					console.error(err);
					if (err instanceof ZodError) {
						return { error: err.issues };
					}
					if (err instanceof FirebaseError) {
						return {
							error: {
								code: err.code,
								message: err.message,
							},
						};
					}
					return { error: err };
				}
			},
		}),
	}),
});

export const { useCreateCheckoutSessionMutation } = checkoutService;
